// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BadgeSummary_badgeTagsWrapper__eE0vz {
    margin: 16px 0;
}
.BadgeSummary_badgeTagsWrapper__eE0vz[data-liststyle='true'] {
    margin: 8px 0;
}

.BadgeSummary_badgeBonusPointEquation__rjto- {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 8px;
}

.BadgeSummary_multiplier__p5GJU {
    color: var(--color-white);
    background-color: var(--color-darkui-accent-3);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0px 4px;
    border-radius: 4px;
    font-family: Rubik;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    pointer-events: none;
}

.BadgeSummary_equation1__dLcsR {
    color: var(--color-darkui-accent-3);
}

.BadgeSummary_equation2__jgVFo {
    color: var(--color-orange-light-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/badges/components/BadgeSummary.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".badgeTagsWrapper {\n    margin: 16px 0;\n}\n.badgeTagsWrapper[data-liststyle='true'] {\n    margin: 8px 0;\n}\n\n.badgeBonusPointEquation {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n}\n\n.multiplier {\n    color: var(--color-white);\n    background-color: var(--color-darkui-accent-3);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px 4px;\n    border-radius: 4px;\n    font-family: Rubik;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 18px;\n    pointer-events: none;\n}\n\n.equation1 {\n    color: var(--color-darkui-accent-3);\n}\n\n.equation2 {\n    color: var(--color-orange-light-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badgeTagsWrapper": `BadgeSummary_badgeTagsWrapper__eE0vz`,
	"badgeBonusPointEquation": `BadgeSummary_badgeBonusPointEquation__rjto-`,
	"multiplier": `BadgeSummary_multiplier__p5GJU`,
	"equation1": `BadgeSummary_equation1__dLcsR`,
	"equation2": `BadgeSummary_equation2__jgVFo`
};
export default ___CSS_LOADER_EXPORT___;
